import { MdLocationOn, MdEmail, MdLocalPhone } from "react-icons/md";
import ziellogo from "../ZielLogo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footercontainer">
      <div className="logocontainer">
        <img src={ziellogo} alt="" />
      </div>
      <div className="infoleft">
        <p>
          <MdLocationOn /> <br />
          Proudly serving Hamilton, Madison, Tipton, Howard, and Boone Counties
        </p>
      </div>
      <div className="inforight">
        <p>
          <a href="mailto:contact@zielindiana.com">
            <MdEmail /> <br />
            contact@zielindiana.com
          </a>
        </p>
        <p>
          <a href="123-456-7890">
            <MdLocalPhone /> <br />
            (765) 821-3177
          </a>
        </p>
      </div>
      <div className="copyright">
        Copyright &copy; {currentYear} ZIEL Indiana. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
